import fetch from '@/utils/fetch'

// 获取PC授权
export function getToken (orgId) {
  return fetch({
    url: '/api/account/pc/authorize?orgId=' + orgId,
    method: 'post'
  })
}

// 根据门票可售列表
export function allowSaleList (data) {
  return fetch({
    url: '/api/integration/allow-sale-list',
    method: 'post',
    data
  })
}

// 创建订单
export function createOrder (data) {
  return fetch({
    url: '/trip/order/save-pc-fast-order',
    method: 'post',
    data
  })
}

// 支付与确认订单
export function payConfirm (data) {
  return fetch({
    url: '/api/integration/pay-and-confirm',
    method: 'post',
    data
  })
}

// 是否需要验证码
export function qucikBuyCode () {
  return fetch({
    url: '/bms/sys-config/info-by-code/QuickBuyCode',
    method: 'post'
  })
}

// 最大限购数量
export function maxQuantit () {
  return fetch({
    url: '/bms/sys-config/info-by-code/OFFLINE_FAST_VISITOR_LIMIT',
    method: 'post'
  })
}

// 系统配置接口
export function getInfoConfiguration (code) {
  return fetch({
    url: '/bms/sys-config/info-by-code/' + code,
    method: 'post'
  })
}

// 获取验证码
export function sendCode (data) {
  return fetch({
    url: '/sms/message-send/sendCode',
    method: 'post',
    data
  })
}
// 验证码是否正确
export function checkCode (data) {
  return fetch({
    url: '/sms/message-send/checkCode',
    method: 'post',
    data
  })
}

// 查询订单
export function queryOrder (data) {
  return fetch({
    url: '/api/query/tickets/customer/page',
    method: 'post',
    data
  })
}

// 检票记录
export function checkLog (data) {
  return fetch({
    url: '/api/integration/check/log/list',
    method: 'post',
    data
  })
}

// 检票记录
export function getCheckType (data) {
  return fetch({
    url: '/bms/check/checkType',
    method: 'post',
    data
  })
}

// 退订单
export function cancelOrder (data) {
  return fetch({
    url: '/api/integration/refund',
    method: 'post',
    data
  })
}

// 获取退票信息
export function queryRefund (data) {
  return fetch({
    url: '/api/integration/get-ticket-for-refund',
    method: 'post',
    data
  })
}

// 发起退款
export function refund (data) {
  return fetch({
    url: '/api/integration/refund',
    method: 'post',
    data
  })
}
// 获取窗口支付方式
export function payWayList () {
  return fetch({
    url: '/api/integration/pay-way/list',
    method: 'post'
  })
}

// 验证是否支付成功
export function checkPay (data) {
  return fetch({
    url: '/api/query/order/info',
    method: 'post',
    data
  })
}

// 证件类型
export function cardtypeList () {
  let typeCode = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  if (typeCode === 'Simplified_Chinese') {
    return fetch({
      url: '/bms/cardtype/list',
      method: 'post'
    })
  } else {
    return fetch({
      url: '/bms/dict/list/' + typeCode + '_certificateType',
      method: 'post'
    })
  }
}

// 获取数据字典
export function getDictList (typeCode) {
  return fetch({
    url: '/bms/dict/list/' + typeCode,
    method: 'post'
  })
}

// 获取特殊语言数据字典
export function getDictList2 () {
  let typeCode = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  if (typeCode !== 'Simplified_Chinese') {
    typeCode += '_specialCertificateType'
  } else {
    typeCode = 'specialCertificateType'
  }
  return fetch({
    url: '/bms/dict/list/' + typeCode,
    method: 'post'
  })
}

// 系统设置
export function sysConfig (data) {
  return fetch({
    url: '/trip/quick/template/info-by-typeCode',
    method: 'post',
    data
  })
}

// 查询航线列表
export function flightLineList () {
  return fetch({
    url: '/api/integration/flight-line-list',
    method: 'post'
  })
}
// 查询可售航班列表
export function allowFerrySaleList (data) {
  return fetch({
    url: '/api/integration/flight-no-list',
    method: 'post',
    data
  })
}
// 查询航班组合票可售列表
export function queryGoods (data) {
  return fetch({
    url: '/api/integration/flight-allow-sale-list',
    method: 'post',
    data
  })
}

// 创建航班订单
export function createFeeryOrder (data) {
  return fetch({
    url: '/api/integration/save-flight-combined',
    method: 'post',
    data
  })
}

// 查询分时段预约配置
export function reservationConfig (data) {
  return fetch({
    url: '/api/integration/wechatmini/staggered-reservation-config/info',
    method: 'post',
    data
  })
}

// 查询分时段数据
export function reservationDaily (data) {
  return fetch({
    url: '/api/integration/wechatmini/staggered-reservation-daily/list',
    method: 'post',
    data
  })
}

// 确认订单
export function payAndConfirm (data) {
  return fetch({
    url: '/trip/order/confirm',
    method: 'post',
    data
  })
}

// 微信扫码登录授权接口
export function Login (returnUrl) {
  return fetch({
    url: '/api/account/qr-connect/authorize?returnUrl=' + returnUrl,
    method: 'get'
  })
}

// 微信token获取用户信息
export function getInfo () {
  return fetch({
    url: 'bms/customer/get-wx-userinfo',
    method: 'post'
  })
}

// 获取一周余票量
export function standByList (data) {
  return fetch({
    url: '/api/integration/wechatmini/staggered-reservation-daily/range/standby/list',
    method: 'post',
    data
  })
}

// 文章类别
export function getCategory () {
  return fetch({
    url: '/information/articleCategory/listCategoryName',
    method: 'post'
  })
}

// 最新公告
export function getLatestAnnouncement (data) {
  return fetch({
    url: '/information/article/page',
    method: 'post',
    data
  })
}

// 获取系统参数
export function getPreSaleDays () {
  return fetch({
    url: '/bms/sys-config/info-by-code/PRE_SALE_DAYS',
    method: 'post'
  })
}

// 维护
export function getSystemUpdate () {
  return fetch({
    url: '/bms/sys-config/system-maintenance-notice',
    method: 'post'
  })
}

// 支付查询
export function PayForTheQuery (orderNo) {
  return fetch({
    url: `/pay/jsapi/check-unpaid/${orderNo}`,
    method: 'post'
  })
}

// 支付查询
export function certificateNo (data) {
  return fetch({
    url: `/rule/ban-sale-rule/validate`,
    method: 'post',
    data
  })
}

// 获取票种
export function getGoodsInfo (id) {
  return fetch({
    url: `/trip/goods/goods-ticket/info/` + id,
    method: 'post'
  })
}

// 获取票种
export function getTicketKind (data) {
  return fetch({
    url: `/trip/goods/goods-ticket-kind/get-ticket-kind-by-rule`,
    method: 'post',
    data
  })
}

// 手机号校验
export function contactMobileValidate (data) {
  return fetch({
    url: '/bms/black/certificate/is-exist-contact',
    method: 'post',
    data
  })
}

// 节流 用于防止用户短时间内多次点击
export function throttle (fn, delay) {
  let last = 0 // 上次触发时间
  return function (...args) {
    const now = Date.now()
    if (now - last > delay) {
      last = now
      fn.apply(this, args)
    }
  }
}

// 解密
export function decrypt (data) {
  return fetch({
    url: '/bms/util/desensitization-decrypt',
    method: 'POST',
    data
  })
}

// 分时段倒查
export function getStaggeredReservationDailyForShow (data) {
  return fetch({
    url: '/api/integration/getStaggeredReservationDailyForShow',
    method: 'POST',
    data
  })
}
